import { doc, FieldPath, getDoc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore'
import { db } from 'config/firebase'
import { isAssistantDemoDismissed } from './assistantDemoDismiss'

const COLLECTION = 'userAssistantSettings'

export async function readAssistantDemoDismissed(uid: string, demoId: string): Promise<boolean> {
  const snap = await getDoc(doc(db, COLLECTION, uid))
  return isAssistantDemoDismissed(snap.data(), demoId)
}

/** Stores "don't show me this again" on the signed-in user's assistant settings. */
export async function writeAssistantDemoDismissed(uid: string, demoId: string): Promise<void> {
  const ref = doc(db, COLLECTION, uid)
  const snap = await getDoc(ref)
  if (snap.exists()) {
    await updateDoc(
      ref,
      new FieldPath('dismissedDemos', demoId),
      true,
      'updatedAt',
      serverTimestamp(),
    )
    return
  }
  await setDoc(ref, {
    dismissedDemos: { [demoId]: true },
    updatedAt: serverTimestamp(),
  })
}
